module.exports = __webpack_public_path__ + "static/media/upload.1f0688c9.ico";